import React from 'react';
export function AboutPage() {
  return <main className="flex-grow container mx-auto px-4 md:px-6 py-8 max-w-4xl" data-id="element-461">
      <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-462">
        <h1 className="text-3xl font-bold mb-6" data-id="element-463">About Us – KODIF</h1>
        <div className="space-y-6 text-gray-700" data-id="element-464">
          <p className="text-lg" data-id="element-465">
            KODIF is a platform designed to help you find the best discount,
            promo, and coupon codes for popular online stores and services in
            Estonia. Our goal is to make saving money easy and secure—whether
            you're shopping for electronics, food, fashion, travel, or more.
          </p>
          <p data-id="element-466">
            All our codes are verified, regularly updated, and can be applied at
            checkout for top brands like Wolt, Bolt Food, Sportland, Euronics,
            McDonald's, Netflix, Apple, Nike, Adidas, and many others. Codes are
            easy to find and quick to use when placing an order.
          </p>
          <p data-id="element-467">
            We also share smart tips on how to avoid scams, check code validity,
            and get the most out of various deals. Our mission is to help you
            save money smartly and safely.
          </p>
        </div>
        <div className="mt-10 border-t border-gray-200 pt-6" data-id="element-468">
          <h2 className="text-xl font-bold mb-4" data-id="element-469">Our Partners</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-470">
            {['Wolt', 'Bolt Food', 'Sportland', 'Euronics', "McDonald's", 'Netflix', 'Apple', 'Nike'].map((brand, index) => <div key={index} className="bg-gray-50 p-3 rounded-lg text-center" data-id="element-471">
                <span className="font-medium" data-id="element-472">{brand}</span>
              </div>)}
          </div>
        </div>
        <div className="mt-10 border-t border-gray-200 pt-6" data-id="element-473">
          <h2 className="text-xl font-bold mb-4" data-id="element-474">Why Choose KODIF?</h2>
          <ul className="list-disc pl-5 space-y-2" data-id="element-475">
            <li data-id="element-476">Verified and regularly updated codes</li>
            <li data-id="element-477">Easy to find and apply at checkout</li>
            <li data-id="element-478">Wide range of categories and stores</li>
            <li data-id="element-479">Smart tips to avoid scams</li>
            <li data-id="element-480">Secure and reliable platform</li>
          </ul>
        </div>
      </div>
    </main>;
}